import { RestModel } from './core/RestModel'
import api from '@/api'

export class ServiceModel extends RestModel {
  constructor(data = {}) {
    super(data, {
      name: 'service',
      endpoint: '/services',
      schema: {
        id: Number,
        key: String,
        title: String,
        description: String,
        icon: String,
        order: Number,
        isActive: Boolean,
        createdAt: String,
        updatedAt: String,
      },
    })
  }

  async getPricing() {
    const ep = this.endpoint({ id: this.getPrimary(), append: '/pricing' })
    const { data } = await api.get(ep)
    return data
  }

  async createPricingItem(payload) {
    const ep = this.endpoint({ id: this.getPrimary(), append: '/pricing' })
    const { data } = await api.post(ep, payload)
    return data
  }

  async updatePricingItem(pricingId, payload) {
    const { data } = await api.put(`/pricing/${pricingId}`, payload)
    return data
  }

  async deletePricingItem(pricingId) {
    const { data } = await api.delete(`/pricing/${pricingId}`)
    return data
  }

  async reorderPricing(ids) {
    const ep = this.endpoint({ id: this.getPrimary(), append: '/pricing/reorder' })
    const { data } = await api.put(ep, { ids })
    return data
  }

  static async reorder(ids) {
    const { data } = await api.put('/services/reorder', { ids })
    return data
  }
}

export default ServiceModel
